import { l as logger } from "../../../../../chunks/logger.js";
import { g as getMongo } from "../../../../../chunks/mongo.js";
const load = async ({ params }) => {
  const mongo = await getMongo();
  const client = mongo.getClient(params.server);
  const adminDb = client.db("test").admin();
  const results = await adminDb.listDatabases();
  if (!Array.isArray(results.databases)) {
    return {
      databases: []
    };
  }
  const filteredDatabases = mongo.filterDatabases(results.databases);
  const databases = await Promise.all(
    filteredDatabases.map(async (d) => {
      const db = client.db(d.name);
      const dbStats = await db.stats().catch(() => {
        logger.error(`Error getting stats for database ${d.name} on server ${params.server}`);
        return {
          dataSize: 0,
          avgObjSize: 0,
          storageSize: 0,
          indexSize: 0,
          collections: 0
        };
      });
      return {
        name: db.databaseName,
        size: d.sizeOnDisk ?? 0,
        dataSize: dbStats.dataSize,
        avgObjSize: dbStats.avgObjSize,
        storageSize: dbStats.storageSize,
        totalIndexSize: dbStats.indexSize,
        empty: d.empty ?? true,
        nCollections: dbStats.collections
      };
    })
  );
  return {
    databases
  };
};
export {
  load
};
